import {connect} from '@gisatcz/ptr-state';

import Select from '../../../../state/Select';

import presentation from './presentation';

const mapStateToProps = state => {
	const mapKey = Select.app.getLocalConfiguration(state, 'data.zones.mapKey');
	const layerKey = Select.app.getLocalConfiguration(
		state,
		'data.zones.layerKeys.zones'
	);

	return {
		feature: Select.insar.getSelectedZoneFeature(state, mapKey, layerKey),
	};
};

export default connect(mapStateToProps)(presentation);
